/*
 * @Author: linbin@leedarson.com
 * @Date: 2022-11-30 09:21:23
 * Copyright © Leedarson. All rights reserved.
 */

// 测试用例: convert({ a: '123', b: 234, c: new Date(), d: /abc/, e: new Error(400), f: () => {}, g: undefined, h: null });
// 注意: 一定要返回新对象, 别的地方可能还需要用原始对象
const convert = (arg: any) => {
  if (Object.prototype.toString.call(arg) === '[object Object]') {
    // 注意：必须返回是新对象，修改原来对象一定存在风险
    const obj: Record<string, any> = {};
    Object.keys(arg).forEach((key) => {
      obj[key] = convert(arg[key]);
    });
    return obj;
  }
  if (Object.prototype.toString.call(arg) === '[object Array]') {
    // 注意：必须返回是新数组，修改原来数组一定存在风险
    return arg.map((item: any) => {
      return convert(item);
    });
  }
  if (typeof arg === 'string' || typeof arg === 'number' || typeof arg === 'boolean') {
    return arg;
  }
  if (arg instanceof Error) {
    return { message: arg.message, stack: arg.stack }; // 建议使用 `new Error('message')`, 因为有堆栈信息
  }
  if (arg instanceof Event) {
    return { message: (arg as any).message, code: (arg as any).code, reason: (arg as any).reason };
  }
  return String(arg); // arg instanceof (RegExp || Function || Date || undefined || null )
};

export default convert;
